export default "__VITE_ASSET__Dez8ZRc$__"